import { gql } from '@apollo/client';

import {
  COMPANY_FIELDS,
  RESUME_FIELDS,
  STATE_COUNTS_FIELDS,
  VACANCY_FIELDS
} from './fields';

export const GET_PROFILE_FULL = gql`
  ${VACANCY_FIELDS}

  ${RESUME_FIELDS}

  ${STATE_COUNTS_FIELDS}

  ${COMPANY_FIELDS}

  query ProfileFull($state: ProfileAdTabStatesEnum = ALL) {
    profile {
      ... on UserProfile {
        id
        email
        walletBalance
        adsStateCounts {
          ...adsStateCounts
        }
        company {
          ...companyFields
        }
        ads(state: $state) {
          nodes {
            ... on Resume {
              ...resumeFields
            }
            ... on Vacancy {
              ...vacancyFields
            }
          }
        }
        candidate {
          id
          firstName
          surname
          patronymic
          name
          gender
          age
          dateOfBirth
          email
          phones
          regionId
          educationId
          experienceId
          logoUrl
          __typename
        }
      }
    }
  }
`;

export const GET_PROFILE_MIN = gql`
  query ProfileMin {
    profile {
      ... on UserProfile {
        id
        email
        walletBalance
        company {
          id
          logoUrl
          name
          phones
          email
        }
        candidate {
          id
          firstName
          surname
          logoUrl
          email
          phones
          patronymic
          gender
          dateOfBirth
          regionId
          regionName
        }
      }
    }
  }
`;
